import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import sha1 from 'crypto-js/sha1';
import { WECOM_APP_CSRF_KEY } from './const';
export var ZhbActionReporter = function () {
  function ZhbActionReporter(option) {
    var _this = this;
    _classCallCheck(this, ZhbActionReporter);
    this.report = function (reportData) {
      return _this.request({
        method: 'post',
        url: _this.url,
        headers: {
          'zhb-csrf-token': _this.getZhbCsrfToken(reportData.corp_id)
        },
        data: reportData
      });
    };
    var request = option.request,
      url = option.url;
    this.request = request;
    this.url = url;
  }
  _createClass(ZhbActionReporter, [{
    key: "getZhbCsrfToken",
    value: function getZhbCsrfToken(corpId) {
      var ts = Date.now() / 1000 | 0;
      return "".concat(ts, ",").concat(sha1(corpId + WECOM_APP_CSRF_KEY + ts));
    }
  }]);
  return ZhbActionReporter;
}();
;
export var createZhbActionReport = function () {
  var reportIns;
  return function (option) {
    var request = option.request,
      url = option.url;
    if (reportIns) {
      return reportIns;
    }
    reportIns = new ZhbActionReporter({
      url: url,
      request: request
    });
    return reportIns;
  };
}();